define('wanavigation', ['jquery', 'waoffcanvas'], function ($, waoffcanvas) {

  return {
    navigation: $('.navigation'),
    largeSubmenus: $('[id^="js_flyout-large"]'),
    menuIcon: $('.menu.js_navigation'),
    offCanvas: $('.offcanvas'),
    currentBreakpoint: window.wabreakpoint,

    desktopNavigation: function desktopNavigation() {
      var _this = this;

      this.navigation.on('mouseenter', '.navigation__item', function (e) {
        var self = $(e.currentTarget);
        _this.currentCatId = self.data('catid');
        _this.currentSubMenu = $('#js_flyout-large-' + _this.currentCatId);

        _this.largeSubmenus.stop(true, true).hide();
        _this.showMenuImages();

        setTimeout(function () {
          _this.currentSubMenu.stop(true, true).fadeIn(100);
          _this.checkPosition();
        }, 250);
      });

      this.navigation.on('mouseleave', function (e) {
        _this.largeSubmenus.stop(true, true).hide();
      });

      this.navigation.on('click', '.navigation__link.main', function (e) {
        if (window.isTouchDevice && window.wabreakpoint === "large") {
          e.preventDefault();
          var self = $(e.currentTarget);
          self.toggleClass('open');
          if (!self.hasClass('open')) {
            window.location = self.attr('href');
          }
        }
      });
    },
    touchNavigation: function touchNavigation() {
      this.menuIcon.on('click', function () {
        waoffcanvas.open('menu');
      });
    },
    checkPosition: function checkPosition() {
      if ($('.navigation nav:hover').length === 0) this.largeSubmenus.stop(true, true).hide();
    },
    showMenuImages: function showMenuImages() {
      var lazyImages = this.currentSubMenu.find('.lazyimage');
      if (!!lazyImages) {
        lazyImages.each(function (i, e) {
          var self = $(e);
          self.attr('src', self.data('src')).removeClass('lazyimage').addClass('lazyloaded');
        });
      }
    },
    init: function init() {
      var _this2 = this;

      this.currentBreakpoint = window.wabreakpoint;
      this.currentBreakpoint === "large" ? this.desktopNavigation() : this.touchNavigation();

      waoffcanvas.close();
      $(window).resize(function () {
        if (_this2.currentBreakpoint !== window.wabreakpoint) {
          _this2.init();
        }
      });
    }
  };
});

